import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * Cart-context variant of QuantitySelectorComponent.
 *
 * The cart's line-item quantity buttons render `<cart-quantity-selector-component>`
 * (chosen by snippets/quantity-selector.liquid when `line_index` is set). Without
 * a registered custom element by that name, the framework never wires up the
 * declarative `on:click="/decreaseQuantity"` / `on:click="/increaseQuantity"`
 * directives in the markup, so the +/- buttons silently do nothing.
 *
 * This subclass inherits all behavior from QuantitySelectorComponent:
 *   - decreaseQuantity / increaseQuantity / setQuantity / selectInputValue handlers
 *   - updateButtonStates() and updateCartQuantity() (called by CartItemsComponent)
 *
 * Quantity changes dispatch a bubbling QuantitySelectorUpdateEvent carrying the
 * line index from the input's `data-cart-line` attribute. The parent
 * CartItemsComponent listens at document level and performs the actual
 * /cart/change.js call.
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
